import PropTypes from 'prop-types';
import React from 'react';

import { Box, Col, Row, Typography } from 'components/AORedesign';

const DetailRowMulti = ({ label, values }) => (
  <Row spacing={2}>
    <Col xs={5}>
      <Typography component="div">
        <Box fontWeight="bold" textAlign="right">
          {label}:
        </Box>
      </Typography>
    </Col>
    <Col xs={7}>
      {values.map((value, index) => (
        <Typography key={index} color="textSecondary">
          {value}
        </Typography>
      ))}
    </Col>
  </Row>
);

DetailRowMulti.propTypes = {
  label: PropTypes.string.isRequired,
  values: PropTypes.array,
};

export default DetailRowMulti;
